<template>
  <div id="integrationsContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img class="icon-pages" src="../assets/images/navbar/ic_integrations.png" />
        <span class="page-title">{{ $t('page.integrations') }}</span>
        <span class="page-des ml-16">{{ $t('page.integrations_description') }}</span>
      </div>
      <div v-if="!userPermLock('reports')">
        <el-tabs class="styleTab" v-model="activeName">
          <el-tab-pane name="overview" default>
            <span slot="label" class="title-bar">{{ $t('page.overview') }}</span>
            <overview @clicked="goToSubPage" @openAppIntegration="openAppIntegration" />
          </el-tab-pane>
          <el-tab-pane name="hrisSync">
            <span slot="label" class="title-bar">{{ $t('page.HRIS_Sync') }}</span>
            <hris-sync />
          </el-tab-pane>
          <el-tab-pane name="api">
            <span slot="label" class="title-bar">{{ $t('page.API') }}</span>
            <api />
          </el-tab-pane>
          <el-tab-pane name="sso">
            <span slot="label" class="title-bar">SSO</span>
            <sso />
          </el-tab-pane>
        </el-tabs>
      </div>
      <page-locked v-else></page-locked>

      <!-- App Integration Dialog (Slack, etc.) -->
      <el-dialog
        :visible.sync="appDialogVisible"
        :title="activeAppIntegration ? activeAppIntegration.name + ' Integration' : ''"
        width="560px"
        top="8vh"
        :close-on-click-modal="false"
        custom-class="app-integration-dialog"
      >
        <component
          v-if="activeAppIntegration"
          :is="activeAppIntegration.component"
          :panel-mode="true"
          @close="closeAppIntegration"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "integrations",
  components: {
    overview: require("./Integrations/overview").default,
    hrisSync: require("./Integrations/HRIS-sync").default,
    api: require("./Integrations/api").default,
    sso: require("./Integrations/sso").default,
    slack: require("./Integrations/slack").default,
    pageLocked: require("./main/page-locked").default,
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "integrations", params: { tab } });
        }
      }
    }
  },
  data() {
    return {
      activeName: "overview",
      appDialogVisible: false,
      activeAppIntegrationId: null,
      anchor: {
        overview: "overview",
        hrisSync: "hrisSync",
        api: "api",
        sso: "sso",
      },
      // App integrations shown in overview section (Slack, Teams, etc.)
      appIntegrations: [
        {
          id: 'slack',
          name: 'Slack',
          component: 'slack'
        }
      ]
    };
  },
  computed: {
    activeAppIntegration() {
      return this.appIntegrations.find(function(i) { return i.id === this.activeAppIntegrationId; }.bind(this));
    }
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;

    // Check if it's a tab or an app integration
    if (params && this.anchor[params]) {
      this.activeName = params;
    } else if (params && this.appIntegrations.find(function(i) { return i.id === params; })) {
      // It's an app integration like 'slack'
      this.activeName = 'overview';
      this.$nextTick(function() {
        this.openAppIntegration(params);
      }.bind(this));
    } else {
      this.$router.push({ name: 'integrations', params: { tab: "overview" } });
    }

    this.$root.$on('changeTab', function(item) {
      if (item.path == "integrations") {
        // Check if it's a tab or an app integration
        if (this.anchor[item.tab]) {
          this.goToSubPage(item.tab);
        } else if (this.appIntegrations.find(function(i) { return i.id === item.tab; })) {
          this.activeName = 'overview';
          this.openAppIntegration(item.tab);
        }
      }
    }.bind(this));
  },
  methods: {
    goToSubPage(value) {
      this.activeName = value;
    },
    openAppIntegration(integrationId) {
      this.activeAppIntegrationId = integrationId;
      this.appDialogVisible = true;
      this.$router.push({ name: 'integrations', params: { tab: integrationId } }).catch(function() {});
    },
    closeAppIntegration() {
      this.appDialogVisible = false;
      this.activeAppIntegrationId = null;
      this.$router.push({ name: 'integrations', params: { tab: 'overview' } }).catch(function() {});
    },
    userPermLock() {
      return this.$utils("permissions", {
        perm: this.$store.getters["authen/pagePermission"],
        path: "reports",
        type: "lock",
        user_type: this.$store.getters["authen/user"].user_type
      });
    },
  }
};
</script>

<style scoped>
.styleTab {
  margin-top: 32px;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #ffffff;
}
</style>

<style>
#integrationsContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#integrationsContainer .el-tabs__header {
  margin: 0;
}

/* Dialog styles for app integrations */
#integrationsContainer .app-integration-dialog {
  border-radius: 12px;
  overflow: hidden;
}

#integrationsContainer .app-integration-dialog .el-dialog__header {
  padding: 16px 24px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}

#integrationsContainer .app-integration-dialog .el-dialog__title {
  font-size: 17px;
  font-weight: 700;
  color: #3b3b3b;
}

#integrationsContainer .app-integration-dialog .el-dialog__body {
  padding: 24px;
  max-height: 72vh;
  overflow-y: auto;
}

#integrationsContainer .app-integration-dialog .el-dialog__headerbtn {
  top: 16px;
  right: 20px;
}
</style>
